import { createSelector } from "reselect";
import { selectUserData } from "./UserDataSelectors";
import type { BaseItem, ProductItem } from "../_stores/UserCartStore";
import Immutable from "immutable";
import type { BrandingOptionStore } from "../_stores/BrandingOptionStore";
import type WebsiteStore from "../../WebsiteStore";

export const selectBrandingOptionsForItem = createSelector(
  [selectUserData, (state:WebsiteStore, item: BaseItem) => item],
  (userData, item) => {
    if(item.get('type') !== 'product') return Immutable.OrderedMap<string, BrandingOptionStore>()

    return Immutable.OrderedMap<string, BrandingOptionStore>().withMutations(brandingOptions => {
      (item as ProductItem).get('options').forEach(option => {
        const brandingOption = option.get('branding_option')

        if (brandingOption) {
          brandingOptions.set(String(brandingOption.get('id')), brandingOption)
          return
        }

        const idBrandingOption = option.get('id_branding_option')
        if (idBrandingOption === undefined || idBrandingOption <= 0) {
          return
        }

        const userBrandingOption = userData.get('brandingOptions').get(String(idBrandingOption))
        if (userBrandingOption) {
          brandingOptions.set(String(userBrandingOption.get('id')), userBrandingOption)
        }
      })
    })
  }, {
  memoizeOptions: {
    resultEqualityCheck: (a: Immutable.OrderedMap<string, BrandingOptionStore>, b: Immutable.OrderedMap<string, BrandingOptionStore>) => {
      return a === b || (
        a instanceof Immutable.OrderedMap
        && b instanceof Immutable.OrderedMap
        && a.count() === b.count()
        && a.every((order, key) => order.equals(b.get(key)))
      )
    }
  }
});
